/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-14 17:45:57
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-04-25 15:37:25
 * @FilePath: \baishu_react_ui\src\components\BsyBatchEditPane\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import { BsyWidget } from "../BsyWidget";
import BsyRadioGroup from "../BsyRadioGroup";
import "./index.css";
import { BsyUtils } from "../../utils/Utils";
import BsyCheckGroup from "../BsyCheckGroup";

import BsyIconBtn from "../BsyIconBtn";
import BsySelect from "../BsySelect";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import { BsyConfig } from "../../global/BsyConfig";

export default class BsyExportFilePane extends BsyWidget {
  static defaultProps = {
    fields: [],
    entryId: null,
    appId: null,
    name: "",
    idList: [],
    authGroupId: null,
    filterMode: "all",
    filter: null,
  };
  constructor(props) {
    super(props);

    this.state = {
      ...props,
      fileFileds: this.getFileField(props.fields),
    };
  }

  getFileField = (fields) => {
    let fileFields = [];
    this.textField = [];
    let that = this;
    BsyUtils.forEach(fields, function (a, d) {
      var e = {
        text: d.text,
        value: d.name,
        type: d.type,
        textName: null,
        nameType: "origin",
      };
      if (BsyConfig().LimitFields.fileExport.indexOf(d.type) > -1) {
        fileFields.push(e);
      }
      if (BsyConfig().LimitFields.ext.indexOf(d.type) > -1) {
        that.textField.push(e);
      }

      "subform" === d.type &&
        BsyUtils.forEach(d.items, function (a, e) {
          var f = {
            value: [d.name, e.name].join("."),
            text: [d.text, e.text].join("."),
            type: e.type,
            textName: null,
            nameType: "origin",
          };

          if (BsyConfig().LimitFields.fileExport.indexOf(f.type) > -1) {
            fileFields.push(f);
          }
          if (BsyConfig().LimitFields.ext.indexOf(f.type) > -1) {
            that.textField.push(f);
          }
        });
    });
    return fileFields;
  };
  getCheckContext = (context) => {
    this.checkContext = context;
  };

  _createDownloadLink = () => {
    const {
      selectedFields,
      filter,
      fileFileds,
      filterMode,
      entryId,
      appId,
      authGroupId,
      idList,
    } = this.state;
    if (BsyUtils.isObjectEmpty(selectedFields)) {
      tipAlert({
        type: "warning",
        msg: React.language("export.file.select.tip"),
      });
      return;
    }

    let newfilter = {};
    if (filterMode !== "all") {
      newfilter = { ...filter };
    }
    let fields = [];
    for (let i = 0; i < fileFileds.length; i++) {
      let element = {};
      if (selectedFields.indexOf(fileFileds[i].value) > -1) {
        element.file = fileFileds[i].value;
        if (fileFileds[i].textName) {
          element.name = fileFileds[i].textName;
        }
        fields.push(element);
      }
    }
    React.axios(
      "/dashboard/app/" + appId + "/form/" + entryId + "/filetask/mkzip",
      {
        authGroupId: authGroupId,
        jsplatform: "React",
        fields: fields,
        idList: idList,
        filter: newfilter,
      }
    )
      .then((res) => {
        new window.FX.Slider({
          title: React.language("export.record"),
          contentWidget: {
            type: "formexportpane",
            appId: appId,
            entryId: entryId,
            creator: window.FX.STATIC.user._id,
            optype: 1,
          },
          onClose: function () {
            // clearTimeout(window.times);
          },
        }).show();
      })
      .catch((res) => {
        console.error(res);
      });
  };

  render() {
    const { selectedFields, fileFileds, filterMode } = this.state;
    return (
      <div className={"bsy-export-file-pane"} ref={this.element}>
        {/* <div
                    className={'title'}
                >
                    <BsyRadioGroup
                        layout={'horizontal'}
                        value={filterMode}
                        items={[{
                            value: "all",
                            text: React.language("export.data.all"),
                        }, {
                            value: "filtered",
                            text: React.language("export.data.filtered")
                        }]}
                        onStopEdit={(e) => {
                            this.setState({
                                filterMode: e,
                            })
                        }}
                    />

                </div> */}

        <div className={"fields-title"}>
          {React.language("export.file.widgetAndName")}
        </div>
        <div className={"fields-list"}>
          <div className={"fields-title"}>
            <div className={"first"}>{React.language("widget.upload")}</div>
            <div className={"sec"}>{React.language("export.file.name")}</div>
          </div>
          <BsyCheckGroup
            key={"grd1" + new Date().getTime()}
            getContext={this.getCheckContext}
            items={fileFileds}
            value={selectedFields}
            onItemCreate={(item, index) => {
              let nameItmes = [
                {
                  text: React.language("export.file.name.origin"),
                  value: "origin",
                },
                {
                  text: React.language("export.file.name.field"),
                  value: "field",
                },
              ];

              let fieldItems = [];
              if (item.value.indexOf(".") > -1)
                fieldItems = [...this.textField];
              else {
                for (let i = 0; i < this.textField.length; i++) {
                  if (this.textField[i].value.indexOf(".") === -1) {
                    fieldItems.push({ ...this.textField[i] });
                  }
                }
              }

              return (
                <div
                  className={
                    item.nameType +
                    " bsy-group-item bsy-check " +
                    (Array.isArray(selectedFields) &&
                    selectedFields.indexOf(item.value) > -1
                      ? " select "
                      : "")
                  }
                  key={"check-item-" + index}
                  onClick={(e) => {
                    this.checkContext._doItemClick(item);
                  }}
                >
                  <i className="icon-bsy-check2"></i>
                  <span title={item.text} className="field-text">
                    {item.text}
                  </span>

                  <div
                    className={"field-list"}
                    style={{
                      display: item.nameType === "origin" ? "none" : "",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <BsySelect
                      allowBlank={false}
                      searchable={false}
                      // visible={item.nameType === 'origin' ? false : true}
                      value={item.textName}
                      items={fieldItems}
                      onStopEdit={(val) => {
                        item.textName = val;

                        let newDD = fileFileds.map((f) => {
                          if (f.value === item.value) {
                            return item;
                          }
                          return f;
                        });

                        this.setState({ fileFileds: newDD });
                      }}
                    ></BsySelect>
                  </div>

                  <div
                    className={"field-type"}
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <BsySelect
                      allowBlank={false}
                      searchable={false}
                      enable={
                        Array.isArray(selectedFields) &&
                        selectedFields.indexOf(item.value) > -1
                          ? true
                          : false
                      }
                      value={item.nameType}
                      items={nameItmes}
                      onStopEdit={(val) => {
                        item.nameType = val;
                        if (val == "origin") {
                          item.textName = "";
                        }
                        let newDD = fileFileds.map((f) => {
                          if (f.value === item.value) {
                            return item;
                          }
                          return f;
                        });

                        this.setState({ fileFileds: newDD });
                      }}
                    ></BsySelect>
                  </div>
                </div>
              );
            }}
            onStopEdit={(e) => {
              this.setState(
                {
                  selectedFields: [...e],
                },
                () => {}
              );
            }}
          ></BsyCheckGroup>
        </div>
        <div className={"fields-footer"}>
          <BsyIconBtn
            mode={window.mode}
            type={"edit-btn"}
            text={React.language("cancel")}
            click={(e) => {
              if (this.props.onCancel) {
                this.props.onCancel();
              }
            }}
          />
          <BsyIconBtn
            mode={window.mode}
            text={React.language("export.generate.downloadLink")}
            type={"blue edit-btn"}
            click={(e) => {
              this._createDownloadLink();
            }}
          ></BsyIconBtn>
        </div>
      </div>
    );
  }
}
